export default "__VITE_ASSET__pst_ezjV__"